import axios from "@/axios";

export const namespaced = true
    export const state = { 
        financeSystems : [],
    }

    export const getters = {
        financeSystems: (state) => state.financeSystems,
    }

    export const mutations = {
        SET_FINANCE_SYSTEMS: (state, response) => {
            state.financeSystems = response.data
        }
    }

    export const actions = {
        async getFinanceSystems({ commit }) {
            commit("SET_FINANCE_SYSTEMS", await axios.get("/api/financesystems"))
        },           
    }
